import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { map, Observable } from 'rxjs';

import type { CultureCode } from '@agency';
import { environment } from '../../../../environments/environment';
import { resolveCostaExtraBaseUrl } from '../config/costa-extra.config';
import type { DisplayBookingRequest } from '../types/display-booking.interfaces';

@Service({ autoProvided: false })
export class CostaExtraApiService {
  private readonly http = inject(HttpClient);

  public validateBooking(culture: CultureCode, bookingNumber: string): Observable<void> {
    const body: DisplayBookingRequest = {
      filters: {
        BookingNumber: bookingNumber,
        BookingNumberTravelAndFriends: '',
      },
    };
    const baseUrl = resolveCostaExtraBaseUrl(environment.name, culture);

    return this.http
      .post(`${baseUrl}/BookingFlowServices.svc/DisplayBooking`, body, {
        withCredentials: true,
        responseType: 'text',
        observe: 'response',
      })
      .pipe(map(() => undefined));
  }
}
